import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-step-base-information',
  templateUrl: './step-base-information.component.html',
  styleUrls: ['./step-base-information.component.scss']
})
export class StepBaseInformationComponent implements OnInit {

  @Output('onValidForm')
  onValidForm = new EventEmitter<boolean>();
  agreeCheckBox=false;
  constructor() { }

  ngOnInit() {
  }

  emitState() {
      this.onValidForm.emit(this.agreeCheckBox);
  }

  toogleCheckbox() {
    this.agreeCheckBox=!this.agreeCheckBox;
    this.emitState();
  }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/step-base-information/step-base-information.component.ts